import { IApplicationState } from '../../types/redux';
import { IPricesFiltersState } from '../../types/developerValuation/pricesFiltersState';

export const developerValuationFiltersState = (state: IApplicationState): IPricesFiltersState => {
  return state.developerValuation.pricesFiltersState;
};
